import { render, staticRenderFns } from "./TimeOffsSettingsPage.vue?vue&type=template&id=561dafce&scoped=true"
import script from "./TimeOffsSettingsPage.vue?vue&type=script&lang=js"
export * from "./TimeOffsSettingsPage.vue?vue&type=script&lang=js"
import style0 from "./TimeOffsSettingsPage.vue?vue&type=style&index=0&id=561dafce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561dafce",
  null
  
)

export default component.exports